import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { uuid } from "../../utils";
import { getFirstName } from "../../utils/getFirstName";
import { PersistState } from "../types";


export const persistStore = create<PersistState>()(
    persist(
        (set, get) => ({
            shown: true,
            userId: uuid(),
            showItems: 0,
            fullSources: false,
            changeCycle: 0,
            automaticMode: false,
            streamingMode: false,
            showComparisonReference: true,
            compactReference: false,
            customizeGreeting: true,
            greetingName: getFirstName(),
            speechPlaybackSpeed: 1.0,
            speechVoice: "",
            changeValue: (key: keyof PersistState, value: any) => {
                set({ [key]: value });
            },
            init: (cycle: number, override?: boolean) => {
                if (get().changeCycle !== cycle || override) {
                    set({ shown: true, changeCycle: cycle });
                }
            },
        }),
        {
            name: "persistStore",
            storage: createJSONStorage(() => localStorage)
        }
    )
);
